import React from "react";

import { Typography } from "@/design-system/components/Typography/Typography";
import { EventSearchMultiSelect } from "@/InsightsPage/EventSearchMultiSelect";
import { WizardStepLayout } from "@/wizards/framework/WizardStepLayout";
import { ConversionEventsStepProps } from "../types";
import { useSavedSelection } from "../useSavedSelection";
import {
  DefineEventPrompt,
  EventOptionsUnavailable,
} from "./EventOptionsStates";

export function MidFunnelStep({
  data,
  updateData,
  context,
  goNext,
}: ConversionEventsStepProps) {
  const { eventOptions, pickerEvents, receivingEvents, retry } =
    useSavedSelection({
      data,
      updateData,
      context,
    });
  const bottomFunnelIds = new Set(data.bottomFunnelIds ?? []);

  return (
    <WizardStepLayout
      title="Add steps along the way"
      description="Mid-funnel events show which campaigns move people closer to converting, like “Started scheduling” or “Submitted contact form”. They’re optional."
      primaryAction={{ label: "Continue", onClick: goNext }}
    >
      {eventOptions.status !== "ready" ? (
        <EventOptionsUnavailable
          eventOptions={eventOptions}
          receivingEvents={receivingEvents}
          retry={retry}
        />
      ) : (
        <div className="flex flex-col gap-2">
          <Typography variant="label-sm">
            Mid-funnel conversion events (up to 20)
          </Typography>
          <EventSearchMultiSelect
            eventDefs={pickerEvents.filter(
              (event) => !bottomFunnelIds.has(event.eventDefId),
            )}
            selectedEventDefIds={data.midFunnelIds ?? []}
            onSelectionChange={(ids) => updateData({ midFunnelIds: ids })}
            placeholder="Search or select conversion events"
            maxSelected={20}
            popoverSide="bottom"
            expandOtherEventsWhenNoneRecommended
          />
          <DefineEventPrompt />
        </div>
      )}
    </WizardStepLayout>
  );
}
